module.exports = __webpack_public_path__ + "img/tty-answer.49b3b83c.svg";